import { IApiConfiguration } from './interfaces';
import { ConciergeGetChatResponse, ConciergeTranscribeSpeechResponse } from '../Screens/ChatPage/models/conciergeContracts';

// Google-signed ID token -> chat token (the API verifies the token with Google's keys).
export const signInWithGoogle: IApiConfiguration<string> = { endpoint: 'api/chat/sign-in/google', method: 'POST', name: 'signInWithGoogle' };
// Sliding session: a fresh token for a still-valid one.
export const refreshChatToken: IApiConfiguration<string> = { endpoint: 'api/auth/chat/refresh', method: 'POST', name: 'refreshChatToken' };
// Sends are de-duplicated per clientTurnId (see ApiClientArchitecture/index.ts), not per URL.
export const sendMessage: IApiConfiguration<boolean> = { endpoint: 'api/chat', method: 'POST', name: 'sendMessage' };
// A spoken question as text (multipart `audio`); the chat then sends the text as the guest's message. The API answers within 15s.
export const transcribeSpeech: IApiConfiguration<ConciergeTranscribeSpeechResponse> = {
   endpoint: 'api/chat/speech',
   method: 'POST',
   name: 'transcribeSpeech',
   multipart: true,
   timeoutMs: 30000
};
// History refetches after reconnect/visibility may overlap with the regular query; both are safe.
export const getChat: IApiConfiguration<ConciergeGetChatResponse> = { endpoint: 'api/chat', method: 'GET', name: 'getChat', skipDedupe: true };
